export default __webpack_public_path__ + "static/media/main-logo.31361cc5.png";